import './sign-in.less';

App.Pages.SignIn = class SignIn extends PF.Page
	{

	static get options()
		{
		return {
			rights: {
				guest: true
			},
			panel: false,
			path: '/sign-in',
			nameRu: 'Гость - аутентификация',
		};
		}

	static get template()
		{
		//language=HTML
		return `
			<div class="page page-background">
				<div class="page-content" pf="pageContent">

					<div class="login-box">
						<div class="login-titl">
							<img src="/favicon.ico" class="login-img">
							Статистика по эмоциям
						</div>
						<form class="block login-form" pf="form">
							<input type="phone" placeholder="Телефон" pf="phone">
							<input type="password" placeholder="Пароль" pf="password">
							<button class="button button-fill" pf="submit">Войти</button>
						</form>
					</div>

					<!--					<div style="text-align: center">-->
					<!--						<p><a href="/forgot">Забыли пароль?</a></p>-->
					<!--						<p><a href="/sign-up">Регистрация</a></p>-->
					<!--					</div>-->
				</div>
			</div>
		`;

		}

	init()
		{
		super.init();

		this.form = new PF.Form({
			notModifyBehavior: 'none',
			dom: {
				element: this.dom.form
			},
			fieldsConfig: {
				phone: {
					class: PF.Field.Phone,
					required: true
				},
				password: {
					class: PF.Field.String,
					required: true
				}
			},
			errors: {
				signInFail: 'Неверный номер телефона или пароль'
			}
		});

		this.form.on('submit', () => {
			app.f7.preloader.show();
			app.request('/auth/sign-in', this.form.model.toJSON(), (response) => {
				app.f7.preloader.hide();
				if (response.status === "OK")
					{
					app.router.navigate('/');
					}
				else
					{
					this.form.setError(response.error);
					}
			});
		});

		app.panelState = null;
		}
	};